import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function TopStrengths({ data, variant }) {
  const topStrengths = useMemo(() => (
    data && Object.keys(data).map(
      (name) => <li key={name} className="mb-4">{name}</li>,
    )
  ), [data]);

  return (
    <div className="h-100 border border-2 rounded-3 p-3">
      <h5 className="mb-4">Top Strengths</h5>

      {!data ? <LoadingPlaceholder className="mb-3" /> : (
        <ol className={`with-counter bg-${variant}-counter fw-semibold`}>
          {topStrengths}
        </ol>
      )}
    </div>
  );
}

TopStrengths.propTypes = {
  data: PropTypes.object,
  variant: PropTypes.string.isRequired,
};

TopStrengths.defaultProps = {
  data: null,
};
